module.exports = {render:function anonymous(
) {
with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","aria-labelledby":"caret-down","viewBox":"0 0 2300 2300"}},[_c('title',[_v("caret-down")]),_c('path',{attrs:{"d":"M340.5 490.5l-80 60 910 1260 870-1260-80-60-790 1140z"}})])}
}};